import {Card, Toggle} from '@atoms';
import {Group, actions, getShowWeekends, useAppDispatch, useAppSelector} from '@lib/store';
import {useCallback} from 'react';
import {ListHeader} from '../../Connections/components';
import {P} from '@quarks';
import {useTranslation} from 'react-i18next';

type Props = {};

export const GroupPreferencesSection = ({group}: {group: Group}) => {
  const {t} = useTranslation();
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector((state) => state.data.user.user.id);
  const showWeekends = useAppSelector(getShowWeekends);

  const toggleShowWeekends = useCallback(
    async (next: boolean) => {
      await dispatch(actions.setShowWeekends(next));
    },
    [dispatch],
  );

  return (
    <Card className="flex flex-col py-8 gap-6">
      <ListHeader
        title={t('Preferences')}
        className="sm:px-4 px-6"
      />

      <div className="grid gap-2 grid-cols-[1fr_auto] items-center sm:px-4 px-6">
        <P>{t('groups:ShowWeekendDaysLabel')}</P>
        <Toggle
          checked={showWeekends}
          onChange={(e) => toggleShowWeekends(e.currentTarget.checked)}
        />
      </div>
    </Card>
  );
};
